import { Route, Routes } from 'react-router-dom';
import RunsSettingItem from './runs-setting-item';
import RunsSettingList from './runs-setting-list';

const RunsSettingsRouting = () => {
  return (
    <Routes>
      <Route path='' element={<RunsSettingList />} />
      <Route path=':uid' element={<RunsSettingItem />} />
    </Routes>
  );
};

export default RunsSettingsRouting;
